/**
 * Country data with codes, names, and flag image URLs
 */

export const countriesData = [
  { code: 'US', name: 'United States', flag: 'https://flagcdn.com/us.svg' },
  { code: 'GB', name: 'United Kingdom', flag: 'https://flagcdn.com/gb.svg' },
  { code: 'CA', name: 'Canada', flag: 'https://flagcdn.com/ca.svg' },
  { code: 'AU', name: 'Australia', flag: 'https://flagcdn.com/au.svg' },
  { code: 'IN', name: 'India', flag: 'https://flagcdn.com/in.svg' },
  { code: 'DE', name: 'Germany', flag: 'https://flagcdn.com/de.svg' },
  { code: 'FR', name: 'France', flag: 'https://flagcdn.com/fr.svg' },
  { code: 'IT', name: 'Italy', flag: 'https://flagcdn.com/it.svg' },
  { code: 'ES', name: 'Spain', flag: 'https://flagcdn.com/es.svg' },
  { code: 'JP', name: 'Japan', flag: 'https://flagcdn.com/jp.svg' },
  { code: 'CN', name: 'China', flag: 'https://flagcdn.com/cn.svg' },
  { code: 'BR', name: 'Brazil', flag: 'https://flagcdn.com/br.svg' },
  { code: 'MX', name: 'Mexico', flag: 'https://flagcdn.com/mx.svg' },
  { code: 'RU', name: 'Russia', flag: 'https://flagcdn.com/ru.svg' },
  { code: 'KR', name: 'South Korea', flag: 'https://flagcdn.com/kr.svg' },
  { code: 'NL', name: 'Netherlands', flag: 'https://flagcdn.com/nl.svg' },
  { code: 'SE', name: 'Sweden', flag: 'https://flagcdn.com/se.svg' },
  { code: 'CH', name: 'Switzerland', flag: 'https://flagcdn.com/ch.svg' },
  { code: 'SG', name: 'Singapore', flag: 'https://flagcdn.com/sg.svg' },
  { code: 'AE', name: 'United Arab Emirates', flag: 'https://flagcdn.com/ae.svg' },
  { code: 'ZA', name: 'South Africa', flag: 'https://flagcdn.com/za.svg' },
  { code: 'IL', name: 'Israel', flag: 'https://flagcdn.com/il.svg' },
  { code: 'TR', name: 'Turkey', flag: 'https://flagcdn.com/tr.svg' },
  { code: 'SA', name: 'Saudi Arabia', flag: 'https://flagcdn.com/sa.svg' },
  { code: 'AR', name: 'Argentina', flag: 'https://flagcdn.com/ar.svg' },
];

export default countriesData;